import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { FilestackCoreModule, FilestackService } from '@hiptraveler/core/filestack';

import { SupportTicketModalComponent } from './support-ticket-modal.component';
import { SupportTicketModalActionService } from './support-ticket-modal-action.service';
import { SupportTicketUploadDirectiveModule } from './support-ticket-upload.directive';

const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  MatDialogModule,
  MatIconModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  MatSnackBarModule,
  FilestackCoreModule,
  SupportTicketUploadDirectiveModule
];

const COMPONENTS = [
  SupportTicketModalComponent
];

const SERVICES = [
  SupportTicketModalActionService,
  FilestackService
];

@NgModule({
  imports: MODULES,
  declarations: COMPONENTS,
  providers: SERVICES,
  exports: [SupportTicketModalComponent]
})
export class SupportTicketModalModule { }
